export const DELETE_REPORTEXECUTION = 'DELETE_REPORTEXECUTION';
export const UPDATE_REPORTEXECUTION = 'UPDATE_REPORTEXECUTION';
export const UPDATE_REPORTEXECUTIONS_LIST = 'UPDATE_REPORTEXECUTIONS_LIST';
